import styled from 'styled-components';
import COLORS from '../../style/universal.color';
import { SpotTagStyleProps } from '../SpotTag/spotTag.types';
import { SpotTagContainerBreakpoint } from './spotTagContainer.types';

const { mlbWhite, mlbGrey5 } = COLORS;

export const SpotTagCSSContainer = styled.div`
  ul {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
    overflow-x: auto;
    overflow-y: hidden;
    @media (min-width: ${({ layoutBreakPoint }: SpotTagContainerBreakpoint) =>
        layoutBreakPoint}) {
      overflow-x: visible;
      overflow-y: visible;
      flex-wrap: wrap;
    }
    li {
      margin: 0 2rem 0.5rem 0;
    }
  }
`;

export const SpotTagHeader = styled.div`
  font-size: 13px;
  color: ${({ dark }: SpotTagStyleProps) => (dark ? mlbWhite : mlbGrey5)};
  padding-bottom: 1rem;
  text-transform: uppercase;
`;
